import React from "react";
import classNames from "classnames";
import styles from "./RulesDrawer.module.scss";

interface RulesDrawerHeaderProps {
    text: string;
    className?: string;
    children?: React.ReactNode;
}

export const RulesDrawerHeader: React.FC<RulesDrawerHeaderProps> = ({
    text,
    className,
    children,
}) => (
    <header className={classNames(styles.header, className)}>
        <h5 className={styles.title}>{text}</h5>
        {children && <div className={styles.actions}>{children}</div>}
    </header>
);
